<!-- Header -->
@if (globalService.isMobileStyle) {
  <app-topnav [titleI18n]="'app.userSettings_accountSetting.changePassword.title'" [enableBack]="true" />
}

<!-- Body -->
@if (globalService.isMobileStyle) {
  <ion-content class="ion-padding">
    <div class="profile-info">
      <ng-container [ngTemplateOutlet]="changePasswordForm"></ng-container>
    </div>
  </ion-content>
} @else {
  <ng-container [ngTemplateOutlet]="changePasswordForm"></ng-container>
}

<!-- Footer -->
@if (globalService.isMobileStyle) {
  <ion-footer>
    <ion-toolbar>
      <ng-container [ngTemplateOutlet]="submitButton"></ng-container>
    </ion-toolbar>
  </ion-footer>
}

<!-- Submit button -->
<ng-template #submitButton>
  <nz-form-item>
    <nz-form-control [nzOffset]="globalService.isMobileStyle ? 0 : 7" [nzSpan]="globalService.isMobileStyle ? 24 : 12">
      <button
        nz-button
        nzType="primary"
        [nzBlock]="globalService.isMobileStyle"
        [disabled]="form.invalid || (this.loadingSvc.isLoading$ | async)"
        (click)="onSubmit()"
      >
        {{ 'common.button.submit' | i18n }}
      </button>
    </nz-form-control>
  </nz-form-item>
</ng-template>

<!-- Password Template -->
<ng-template #changePasswordForm>
  <form nz-form [formGroup]="form" class="form-add-edit">
    <nz-form-item>
      <nz-form-label [nzSpan]="globalService.isMobileStyle ? 12 : 7" nzLabelAlign="left" nzRequired>
        {{ 'app.userSettings_accountSetting.changePassword.oldPassword' | i18n }}
      </nz-form-label>
      <nz-form-control [nzSpan]="12">
        <app-dynamic-password formControlName="oldPassword" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="globalService.isMobileStyle ? 12 : 7" nzLabelAlign="left" nzRequired>
        {{ 'app.userSettings_accountSetting.changePassword.newPassword' | i18n }}
      </nz-form-label>
      <nz-form-control [nzSpan]="12">
        <app-dynamic-password formControlName="newPassword" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="globalService.isMobileStyle ? 12 : 7" nzLabelAlign="left" nzRequired>
        {{ 'app.userSettings_accountSetting.changePassword.confirmPassword' | i18n }}
      </nz-form-label>
      <nz-form-control [nzSpan]="12" [nzErrorTip]="confirmPassword">
        <app-dynamic-password formControlName="confirmPassword" />
      </nz-form-control>
      <ng-template #confirmPassword let-control>
        @if (control.errors?.['confirm']) {
          {{ 'common.validation.confirmPasswordNotMatch' | i18n }}
        }
      </ng-template>
    </nz-form-item>
    <ng-container [ngTemplateOutlet]="submitButton" *ngIf="!globalService.isMobileStyle"></ng-container>
  </form>
</ng-template>
